import { HTMLAttributes, lazy, memo, Suspense } from 'react';
import { Size } from '@optimus-web/common';
import { PictogramName } from './PictogramName';
import { PictogramElement } from './style';

export type PictogramSize = Exclude<Size, 'extraLarge'>;

export interface PictogramProps extends HTMLAttributes<SVGSVGElement> {
    size?: PictogramSize;
    value: `${PictogramName}`;
    title?: string;
}

export const Pictogram = memo(({ size = 'medium', value, title, ...other }: PictogramProps) => {
    const PictogramSVG = lazy(async () => {
        try {
            // eslint-disable-next-line no-unsanitized/method
            return await import(
                /* webpackChunkName: "pictograms", webpackMode: "lazy-once", webpackPreload: true */ `@optimus-web/assets/src/pictograms/${value}.svg?inline`
            );
        } catch (e) {
            return { default: () => null };
        }
    });
    const a11yProps = 'aria-hidden' in other && other['aria-hidden'] === false ? { role: 'img', title } : {};

    return (
        <Suspense fallback={null}>
            <PictogramElement as={PictogramSVG} size={size} aria-hidden="true" {...a11yProps} {...other} />
        </Suspense>
    );
});
